import axios from "axios";

const Api = axios.create({
       baseURL: 'https://app.flexconsulta.com.br/_api'
});



export default Api;
